import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import _ from 'lodash';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import YouTube from 'react-youtube';

import ageIcon1 from '../../../public/icons/videos1.png';
import ageIcon2 from '../../../public/icons/videos2.png';
import ageIcon3 from '../../../public/icons/videos3.png';
import ageIcon4 from '../../../public/icons/all.png';
import style from './Videos.css';
import {encoder, getYoutubeToken} from '../../utils/util';
import PropTypes from 'prop-types';
import {AgeColors, AgeEnum} from '../../constants';

const STEP = 6;
class Videos extends React.Component {
  static contextTypes = { fetch: PropTypes.func.isRequired };
  state = {
    activities: [],
    filteredActivities: [],
    loadedActivities: [],
    selectedAge: -1,  // All ages
    hasMoreItems: true,
    nextPage: 0
  };

  async componentWillMount() {
    const resp = await this.context.fetch(`/api/allActivitiesWithVideo`, {
      method: 'GET'
    });
    let activities = {};
    const activitiesData = await resp.json();
    if (activitiesData) {
      activities = activitiesData.map(act => {
        const activity = act.json_content;
        activity.id = act.id;
        return activity;
      });
    }
    this.setState({
      activities,
      filteredActivities: activities,
      loadedActivities: activities.slice(0, STEP),
      nextPage: 1 // increase nextPage as the page 0 is loaded at the beginning
    });
  }

  getColor(age) {
    switch (age) {
      case AgeEnum.IT:
          return AgeColors.IT;
      case AgeEnum.PSC:
        return AgeColors.PSC;
        case AgeEnum.OSC:
        return AgeColors.OSC;
      default:
        return AgeColors.ALL;
    }
  }

  getSelectedAgeLabelStyle(age) {
    const color = age === this.state.selectedAge ? this.getColor(age) : 'transparent';
    return { borderBottom: `solid 2px ${color}` };
  }

  filterVideos(age) {
    let filteredActivities;
    if (age && this.state.activities) {
      filteredActivities = _.filter(this.state.activities, activity => activity.age === age);
    } else {
      filteredActivities = this.state.activities;
    }
    this.setState({
      filteredActivities,
      loadedActivities: filteredActivities.slice(0, STEP),
      nextPage: 1, // increase nextPage as the page 0 is loaded at the beginning
      hasMoreItems: true,
      selectedAge: age
    });
  }

  async loadVideos() {
    const nextPage = this.state.nextPage;
    const totalActivities = this.state.filteredActivities;
    if (totalActivities.length) { // componentWillMount() should be called first to fetch data
      if (this.state.hasMoreItems) {
        let loadedActivities = this.state.loadedActivities;
        loadedActivities = loadedActivities.concat(
          totalActivities.slice(nextPage * STEP, Math.min((nextPage + 1) * STEP, totalActivities.length)));
        this.setState({
          loadedActivities,
          nextPage: nextPage + 1,
          hasMoreItems: totalActivities.length > (nextPage + 1) * STEP
        });
      }
    }
  }

  render() {
    const loader = <div className='loader'>Loading ...</div>;

    let boxes = this.state.loadedActivities.map((item, index) => {
      return (
        <div className={'col-md-4'} key={`item-${index}`}>
          <div className={style.videoBox}>
            <YouTube
              videoId={getYoutubeToken(item.videoUrl)}
              className={cx(style.youtube)}
              opts={{ width: '100%', height: '400px' }}/>
            <div className={style.videoTitle} style={{color: this.getColor(item.age)}}>
              {item.title}
            </div>
            <div className={style.activityLink}>
              <a
                style={{backgroundColor: this.getColor(item.age)}}
                href={`/activity/${encoder(item.id)}`}
                title={item.title}
                key={`${item.title}-${index}`}>
                Read Activity
              </a>
            </div>
          </div>
        </div>
      )
    });

    return (
      <div className='container-fluid'>
        <div className={cx('row', style.rowContainer)}>
          <div className={style.topContainer}>
            <div className={cx(style.iconBox)}>
              <div className={style.iconBoxImageWrapper}>
                <img src={ageIcon1}
                     style={{backgroundColor: this.getColor(AgeEnum.IT)}}
                     title='Filter videos by age group'
                     onClick={() => this.filterVideos(AgeEnum.IT)}/>
              </div>
              <div className={style.iconBoxBody}>
                <div className={style.iconBoxTitle} style={this.getSelectedAgeLabelStyle(AgeEnum.IT)}>
                  Infant & Toddler
                </div>
              </div>
            </div>
            <div className={cx(style.iconBox)}>
              <div className={style.iconBoxImageWrapper}>
                <img src={ageIcon2}
                     style={{backgroundColor: this.getColor(AgeEnum.PSC)}}
                     title='Filter videos by age group'
                     onClick={() => this.filterVideos(AgeEnum.PSC)}/>
              </div>
              <div className={style.iconBoxBody}>
                <div className={style.iconBoxTitle} style={this.getSelectedAgeLabelStyle(AgeEnum.PSC)}>
                  Group Daycare
                </div>
              </div>
            </div>
            <div className={cx(style.iconBox)}>
              <div className={style.iconBoxImageWrapper}>
                <img src={ageIcon3}
                     style={{backgroundColor: this.getColor(AgeEnum.OSC)}}
                     title='Filter videos by age group'
                     onClick={() => this.filterVideos(AgeEnum.OSC)}/>
              </div>
              <div className={style.iconBoxBody}>
                <div className={style.iconBoxTitle} style={this.getSelectedAgeLabelStyle(AgeEnum.OSC)}>
                  Preschool
                </div>
              </div>
            </div>
            <div className={cx(style.iconBox)}>
              <div className={style.iconBoxImageWrapper}>
                <img src={ageIcon4}
                     style={{backgroundColor: '#E02F2F'}}
                     title='Show all videos'
                     onClick={() => this.filterVideos()}/>
              </div>
              <div className={style.iconBoxBody}>
                <div className={style.iconBoxTitle} style={this.getSelectedAgeLabelStyle(-1)}>
                  All Videos
                </div>
              </div>
            </div>
          </div>
          <div className={cx('row', style.videosContainer)}>
            <InfiniteScroll
              pageStart={0}
              loadMore={this.loadVideos.bind(this)}
              hasMore={this.state.hasMoreItems}
              loader={loader}>
                {boxes}
            </InfiniteScroll>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(style)(Videos);



// WEBPACK FOOTER //
// ./src/routes/videos/Videos.js